import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getSubtitlesTemplates } from "./actions";

export const subtitleTemplatesEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.id,
});

const initialState = subtitleTemplatesEntityAdapter.getInitialState({
  count: 0,
  modals: {},
});

export const subtitleTemplatesSlice = createSlice({
  name: "subtitleTemplates",
  initialState: initialState,
  reducers: {
    showCreateSubtitlesTemplatesModal: (state, action) => {
      console.log("showCreateSubtitlesTemplatesModal", action.payload);
      state.modals.createSubtitlesTemplatesModal = action.payload;
    },
    showSubtitlesTemplateDeleteModal: (state, action) => {
      state.modals.subtitlesTemplateDeleteModal = action.payload;
    },
    showSaveSubtitlesTemplateModal: (state, action) => {
      state.modals.saveSubtitlesTemplateModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubtitlesTemplates.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        subtitleTemplatesEntityAdapter.setAll(state, action.payload.data?.data || []);
        state.count = action.payload?.data?.totalCount;
      } else {
        state.ids = [];
        state.count = 0;
        state.entities = {};
      }
    });
  },
});

export const { showCreateSubtitlesTemplatesModal, showSubtitlesTemplateDeleteModal, showSaveSubtitlesTemplateModal } =
  subtitleTemplatesSlice.actions;

export default subtitleTemplatesSlice.reducer;
